import { defineMessage } from 'services/localization';

export const messages = {
    heading: defineMessage('new_features_available'),
    tryThemFor14DaysForFree: defineMessage('try_them_for_days_for_free'),
    tryNow: defineMessage('try_now'),
};
